var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCashPoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.4238 25.574L27.7974 0.569477C27.6273 0.388954 27.4252 0.245735 27.2028 0.148017C26.9803 0.0502985 26.7419 0 26.5011 0C26.2603 0 26.0218 0.0502985 25.7994 0.148017C25.5769 0.245735 25.3749 0.388954 25.2048 0.569477L1.57836 25.574C0.890045 26.303 0.5 27.2932 0.5 28.3259C0.5 30.4704 2.14622 32.2139 4.17101 32.2139H6.66041V50.056C6.66041 51.1313 7.48066 52 8.49592 52H22.8301V38.3921H29.2543V52H44.5062C45.5215 52 46.3417 51.1313 46.3417 50.056V32.2139H48.8311C49.8063 32.2139 50.7412 31.8069 51.4295 31.0718C52.8578 29.5531 52.8578 27.0927 51.4238 25.574Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashPoint);
export default __webpack_public_path__ + "static/media/cashPoint.0cb2436af3ebb9505e6ef3e9264db829.svg";
export { ForwardRef as ReactComponent };